import React from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";

import { CssBaseline } from "@material-ui/core";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";

const themes = {
  dark: createMuiTheme({
    palette: {
      type: `dark`,
      primary: {
        main: "#4267b2"
      }
    }
  }),
  light: createMuiTheme({
    palette: {
      type: `light`,
      primary: {
        main: "#4267b2"
      }
    }
  })
};

const selectTheme = createSelector(
  state => themes[state.preferences.theme],
  _.identity
);

const Theme = ({ children }) => {
  const theme = useSelector(selectTheme);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default Theme;
